// extracted by mini-css-extract-plugin
export default {"button":"AddSuperCollection_button__VKPtZ"};